export default [{
	path: '/eshop-attributes',
	component: () => import('@/components/eshop-attributes/List')
}]
